import { createApi } from "@reduxjs/toolkit/query/react";
import { appBaseQuery } from "../../services/baseQuery";
import { buildPagedListUrl } from "../../services/queryParams";

export const processApi = createApi({
  reducerPath: "processApi",
  baseQuery: appBaseQuery,
  tagTypes: ["Process"],
  endpoints: (builder) => ({
    getProcesses: builder.query({
      query: (params = {}) => buildPagedListUrl("process/", params),
      providesTags: ["Process"],
    }),
  }),
});

export const {
  useGetProcessesQuery,
  useLazyGetProcessesQuery,
} = processApi;
